import { uploadDataSetter } from '../util/fnTypes'
import { formatBytes } from '../util/resizedImageUrl'
import { OrgType, useAPI } from '../util/useAPI'
import { AlertSeverity, useLoading } from './useLoading'

export interface UploadData {
  type?: OrgType // leave undefined for user
  id?: string // npo or org id
  uploadUrl: string
  imageUrl: string
  fileId: string
  file?: File
  noExtension?: boolean
}

export interface UploadProps {
  get: UploadData
  set: uploadDataSetter
  imageUrl: string
  setImageUrl: (url: string) => void
}

export const defaultAllowedTypes = ["image/png", "image/jpeg", "image/webp", "image/svg+xml"]
export const defaultMaxSize = 10485760

export default function useProcessImage(allowedTypes: string[], maxSize: number, uploadProps?: UploadProps) {
  const FieldDayAPI = useAPI()
  const { loadStart, loadEnd, setAlert } = useLoading();

  return function(file?: File) {
    if (!uploadProps) {
      setAlert(AlertSeverity.INFO, "You can add images to complete your profile after you create your page")
      return
    }
    if (!file) {
      setAlert(AlertSeverity.ERROR, "No file recognized")
      return
    }
    if (!allowedTypes.includes(file.type)) {
      setAlert(AlertSeverity.ERROR, `Unsupported file type: ${file.type}`)
      return
    }
    if (file.size > maxSize) {
      setAlert(AlertSeverity.ERROR, `File size too large. ${formatBytes(file.size)} is more than ${formatBytes(maxSize)}`)
      return
    }
    loadStart(true)
    FieldDayAPI.getUploadUrl(uploadProps.get.type, uploadProps.get.id, uploadProps.get.noExtension)
      .then(async response => {
        response.file = file
        response.noExtension = uploadProps.get.noExtension
        uploadProps.set({ ...uploadProps.get, ...response })

        // create image preview with createObjectURL and set as img src
        const url = URL.createObjectURL(file);
        uploadProps.setImageUrl(url)
      }).catch(err => {
        setAlert(AlertSeverity.ERROR, `Error getting upload destination: ${err}`)
      }).finally(() => loadEnd())
  }

}
